<template>
  <v-container>
    <h1>Beneficiarios</h1>
    <v-row class="ma-0">
      <v-spacer></v-spacer>
      <v-col class="pa-0 mb-4" style="display: flex; justify-content: flex-end;">
        <v-btn
          color="black" 
          elevation="8" 
          class="white--text my-2"
          style="border-radius: 36px; border: 2px solid black; font-family: 'montserrat-semibold'; text-transform: none;" 
          @click="createBeneficiary = true"
          :disabled="!permissionList.includes('createBeneficiary')"
        >
          {{ "Create beneficiary" }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="ma-0">
      <v-col class="pa-0 mb-4">
        <v-text-field
          v-model="busqueda"
          placeholder="Buscar beneficiario"
          clearable
          hide-details
          outlined
          style="width: 300px; font-family: 'montserrat-medium'; border-radius: 20px;"
          prepend-inner-icon="mdi-magnify"
        />
      </v-col>
      <v-col class="d-flex justify-end pa-0 my-4">
        <v-btn color="black" elevation="8" class="white--text ml-4" style="border-radius: 36px; border: 2px solid #000000; font-family: 'montserrat-semibold'; text-transform: none;" @click="dataXLSX()">
          <v-img class="mr-2" src="../../assets/icons/Vector.svg" style="width: 14px;"></v-img>
          {{ "Descargar" }}
        </v-btn>
      </v-col>
    </v-row>
    <v-skeleton-loader type="table" v-if="isLoading" />
    <v-data-table class="d-none d-sm-block" v-else :items-per-page="10" hide-default-header :items="paymentsRecipients" style="background-color: white !important">
      <template v-slot:header="{ props }">
        <thead style="background-color: #f9fafd;">
          <tr>
          <th class="header__title left">{{ "Nombre" }}</th>     
          <th class="header__title center">{{ "Mail" }}</th>                                                                                                                                                                                    
          <th class="header__title center">{{ "Nombre de banco" }}</th>                                                                                                                                                                               
          <th class="header__title center">{{ "Clabe" }}</th>                                                                                                                                                                       
          <th class="header__title center">{{ "RFC" }}</th>                                                                                                                                                                     
          <th class="header__title center">{{ "Currency" }}</th>                                                                                                                                                                 
          <th class="header__title center">{{ "Pais" }}</th>
            <th class="header__title right">{{ 'Monto' }}</th> 
          </tr>
        </thead>
      </template>
      <template v-slot:body="{ items }">
        <tbody style="background: #f9fafd;">
          <tr v-for="item in items" :key="item.id">
            <td class="table__item">{{ item.sName }}</td>
            <td class="table__item">{{ item.sEmail }}</td>
            <td class="table__item">{{ item.sBankName }}</td>
            <td class="table__item">{{ item.sAccountNumber ? item.sAccountNumber : item.accountNumber }}</td>
            <td class="table__item">{{ item.sTaxId ? item.sTaxId : " - " }}</td>
            <td class="table__item">{{ item.sAccountCurrency }}</td>
            <td class="table__item">
              <v-img
                v-if="item.sCountry === 'MX'"
                style="border-radius: 5px;"
                src="../../assets/images/Flags_mex.svg"
                alt="mex-flag"
                width="40"
                height="25"
              />
              <v-img
                v-else-if="item.sCountry === 'USA'"
                style="border-radius: 5px;"
                src="../../assets/images/Flags_usa.svg"
                alt="usa-flag"
                width="40"
                height="25"
              />
            </td>
            <td class="table__item">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn :disabled="isLoading" @click="beneficiaryDetail(item)" v-bind="attrs" v-on="on" icon color="black">
                    <v-icon>mdi-eye-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ "Ver detalle" }}</span> 
              </v-tooltip>
              <!-- <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn :disabled="isLoading" @click="getBeneficiary(item)" v-bind="attrs" v-on="on" icon color="black">
                    <v-icon>mdi-file-document-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ "Detalle" }}</span> 
              </v-tooltip> -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn :disabled="isLoading || !permissionList.includes('deleteBeneficiary')" @click="deletePaymentRecipient = item, dialogDelete = true" v-bind="attrs" v-on="on" icon color="red">
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ "Eliminar beneficiario" }}</span> 
              </v-tooltip>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <v-dialog v-if="createBeneficiary" v-model="createBeneficiary" persistent max-width="680">
      <v-card>
        <v-stepper v-model="step" alt-labels elevation="0">
          <v-stepper-header color="black" class="mt-5 mr-15 ml-15" elevation="0" style="justify-content: center; align-items: center; justify-items: center; align-content: center; box-shadow: none;">
            <v-stepper-step :complete="step > 1" step="1" color="black"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 2" step="2" color="black"></v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <!-- Paso 1: Crear un proveedor -->
            <v-stepper-content step="1" elevation="0" class="pt-0" style="width: 680px;">
              <div class="mb-6" style="text-align: center; font-family: 'montserrat-bold'; font-size: 20px;">{{ 'Crear beneficiario' }}</div>
              <v-card-text v-if="!loading">
                <v-container>
                  <v-row>
                    <v-form ref="formNew" style="width: 100%;" lazy-validation v-on:submit.prevent>
                      <v-row>
                        <v-col cols="6" class="pb-0">
                          <v-select
                            :label="'Entity Business *'"
                            required
                            outlined
                            :items="entityBusinessItems"
                            item-text="text"
                            item-value="value"
                            style="border-radius: 10px"
                            v-model="forms.new.sEntityBusiness"
                            :rules="[rules.required]"
                          ></v-select>
                        </v-col>
                        <v-col cols="6" class="pb-0">
                          <v-select
                            :label="'País *'"
                            required
                            outlined
                            :items="country"
                            style="border-radius: 10px"
                            v-model="forms.new.sCountry"
                            :rules="[rules.required]"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" class="pb-0">
                          <v-text-field
                            :label="'Email *'"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sEmail"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row v-if="forms.new.sEntityBusiness === 'PERSON'" class="pb-10">
                        <v-col cols="6">
                          <v-text-field
                            :label="'First Name *'"
                            required
                            hide-details
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sFirstName"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            :label="'Last Name *'"
                            required
                            hide-details
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sLastName"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row v-else>
                        <v-col cols="12">
                          <v-text-field
                            :label="'Nombre del beneficiario *'"
                            required
                            hide-details
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sName"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <div v-if="forms.new.sEntityBusiness !== 'PERSON'" class="mb-4 mt-10" style="background-color: #FFF8E4; display: flex; align-items: center; border-radius: 20px;">
                        <div class="ml-4" style="border-right: #FCCA3D solid 4px; height: 40px"></div>
                        <div class="pa-4" style="font-family: 'montserrat-semibold'; font-size: 14px">{{ "Por favor, asegúrese de que el nombre de la empresa coincide exactamente con el nombre registrado oficialmente en la empresa." }}</div>
                      </div>
                      <div v-if="forms.new.sCountry === 'USA'">
                        <div class="mb-4" style="background-color: #BFD7ED; display: flex; align-items: center; border-radius: 20px;">
                          <div class="ml-4" style="border-right: #0075B8 solid 4px; height: 40px"></div>
                          <div class="pa-4" style="font-family: 'montserrat-semibold'; font-size: 14px">{{ "La dirección debe ser del domicilio del beneficiario y no del banco receptor." }}</div>
                        </div>
                        <v-row>
                          <v-col cols="6" class="pb-0">
                            <v-text-field
                              :label="'Dirección' + '*'"
                              required
                              outlined
                              style="border-radius: 10px"
                              v-model="forms.new.sAddress"
                              :rules="forms.new.sCountry === 'USA' ? [rules.required] : []"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6" class="pb-0">
                            <v-text-field
                              :label="'Código postal' + '*'"
                              required
                              hide-details
                              outlined
                              style="border-radius: 10px"
                              v-model="forms.new.postCode"
                              :rules="forms.new.sCountry === 'USA' ? [rules.required] : []"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row style="margin-top: -10px;">
                          <v-col cols="6" class="pt-0">
                            <v-text-field
                              :label="'Ciudad' + '*'"
                              required
                              hide-details
                              outlined
                              style="border-radius: 10px"
                              v-model="forms.new.sCity"
                              :rules="forms.new.sCountry === 'USA' ? [rules.required] : []"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6" class="pt-0">
                            <v-text-field
                              :label="'Estado' + '*'"
                              required
                              hide-details
                              outlined
                              style="border-radius: 10px"
                              v-model="forms.new.sState"
                              :rules="forms.new.sCountry === 'USA' ? [rules.required] : []"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </div>
                    </v-form>
                  </v-row>
                </v-container>
              </v-card-text>
              <div v-else style="display: flex; justify-content: center;">
                <v-progress-circular
                  indeterminate
                  color="amber"
                ></v-progress-circular>
              </div>
              <v-card-actions class="pb-4" style="justify-content: space-evenly;">
                <v-btn
                  color="black"
                  elevation="8"
                  class="mr-2 px-6"
                  style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                  outlined
                  :disabled="loading"
                  @click="createBeneficiary = false, forms.new = { sName: '', sEmail: '', sBank_name: '', sAccount_number: '', clabe: '', sCountry: '', currency: 'MXN', sTaxId: '', accountType: '', sState: '', sCity: '', sAddress: '', transferMethod: '', swiftCode: '', postCode: '', sFirstName: '', sLastName: '', sEntityBusiness: 'COMPANY', paymentMethodMX: 'swift' }"
                >
                  {{ 'Cancel' }}
                </v-btn>
                <v-btn
                  color="black"
                  elevation="8"
                  class="white--text px-6"
                  style="border-radius: 36px; border: 2px solid black; font-family: 'montserrat-semibold'; text-transform: none;"
                  @click="nextStep()"
                >
                  {{ 'Continue' }}
                </v-btn>
              </v-card-actions>
            </v-stepper-content>
            <!-- Paso 1: Crear un proveedor -->
            <v-stepper-content step="2" elevation="0" class="pt-0" style="width: 680px;">
              <v-card-text v-if="!loading">
                <v-container>
                  <v-row v-if="forms.new.sCountry === 'MX'">
                    <v-form ref="formSecondStep" style="width: 100%;" lazy-validation v-on:submit.prevent>
                      <v-row>
                        <v-col cols="6" class="pb-0">
                          <v-text-field
                            :label="'Nombre de banco *'"
                            required
                            style="border-radius: 10px"
                            outlined
                            v-model="forms.new.sBank_name"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="pb-0">
                          <v-select
                            :label="'Currency Account *'"
                            required
                            outlined
                            :items="currency"
                            @change="forms.new.sAddress = '', forms.new.sCity = '', forms.new.sState = ''"
                            style="border-radius: 10px"
                            v-model="forms.new.currency"
                            :rules="[rules.required]"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <!-- Selector de método de pago oculto temporalmente para forzar SWIFT en frontend.
                      <v-row v-if="forms.new.sEntityBusiness === 'COMPANY' && forms.new.currency === 'USD'">
                        <v-col cols="12" class="pb-0">
                          <v-select
                            label="Método de pago *"
                            required
                            outlined
                            :items="[
                              // { text: 'SPID', value: 'spid' },
                              { text: 'SWIFT', value: 'swift' }
                            ]"
                            item-text="text"
                            item-value="value"
                            style="border-radius: 10px"
                            v-model="forms.new.paymentMethodMX"
                            :rules="[rules.required]"
                          ></v-select>
                        </v-col>
                      </v-row>
                      -->
                      <!-- SPID temporalmente deshabilitado en frontend.
                      <v-row v-if="forms.new.sEntityBusiness === 'COMPANY' && forms.new.currency === 'USD' && forms.new.paymentMethodMX === 'spid'">
                        <v-col cols="6" class="py-0">
                          <v-text-field
                            :label="'Numero de cuenta *'"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.clabe"
                            :rules="[rules.required, rules.clabeLength]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="py-0">
                          <v-text-field
                            :label="'RFC *'"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sTaxId"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      -->
                      <v-row v-if="forms.new.sEntityBusiness === 'COMPANY' && forms.new.currency === 'USD' && forms.new.paymentMethodMX === 'swift'">
                        <v-col cols="6" class="py-0">
                          <v-text-field
                            label="SWIFT *"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.swiftCode"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="py-0">
                          <v-text-field
                            label="Numero de cuenta *"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.clabe"
                            :rules="[rules.required, rules.clabeLength]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" class="py-0">
                          <v-text-field
                            :label="'RFC *'"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sTaxId"
                            :rules="[]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row v-else-if="forms.new.sEntityBusiness === 'COMPANY' && forms.new.currency === 'MXN'">
                        <v-col cols="6" class="py-0">
                          <v-text-field
                            :label="'Numero de cuenta *'"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.clabe"
                            :rules="[rules.required, rules.clabeLength]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="py-0">
                          <v-text-field
                            :label="'RFC *'"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sTaxId"
                            :rules="[]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row v-else-if="forms.new.sEntityBusiness === 'PERSON'">
                        <v-col cols="6" class="py-0">
                          <v-text-field
                            :label="'Numero de cuenta *'"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.clabe"
                            :rules="[rules.required, rules.clabeLength]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="py-0">
                          <v-text-field
                            :label="'RFC *'"
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sTaxId"
                            :rules="[]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row v-if="forms.new.sEntityBusiness === 'PERSON' && forms.new.currency === 'USD'" class="mt-5 mb-4">
                        <v-col cols="12" class="pt-0">
                          <v-text-field
                            label="SWIFT Code *"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.swiftCode"
                            :rules="forms.new.currency === 'USD' ? [rules.required] : []"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <div v-if="forms.new.currency === 'USD'">
                        <div class="mb-4" style="background-color: #BFD7ED; display: flex; align-items: center; border-radius: 20px;">
                          <div class="ml-4" style="border-right: #0075B8 solid 4px; height: 40px"></div>
                          <div class="pa-4" style="font-family: 'montserrat-semibold'; font-size: 14px">{{ "La dirección debe ser del domicilio del beneficiario y no del banco receptor." }}</div>
                        </div>
                        <v-row>
                          <v-col cols="6" class="pb-0">
                            <v-text-field
                              :label="'Dirección' + '*'"
                              required
                              outlined
                              style="border-radius: 10px"
                              v-model="forms.new.sAddress"
                              :rules="forms.new.currency === 'USD' ? [rules.required] : []"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6" class="pb-0">
                            <v-text-field
                              :label="'Código postal' + '*'"
                              required
                              hide-details
                              outlined
                              style="border-radius: 10px"
                              v-model="forms.new.postCode"
                              :rules="forms.new.currency === 'USD' ? [rules.required] : []"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row style="margin-top: -5px;" class="pb-10">
                          <v-col cols="6" class="pt-0">
                            <v-text-field
                              :label="'Ciudad' + '*'"
                              required
                              hide-details
                              outlined
                              style="border-radius: 10px"
                              v-model="forms.new.sCity"
                              :rules="forms.new.currency === 'USD' ? [rules.required] : []"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6" class="pt-0">
                            <v-text-field
                              :label="'Estado' + '*'"
                              required
                              hide-details
                              outlined
                              style="border-radius: 10px"
                              v-model="forms.new.sState"
                              :rules="forms.new.currency === 'USD' ? [rules.required] : []"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </div>
                    </v-form>
                  </v-row>
                  <v-row v-else-if="forms.new.sCountry === 'USA'">
                    <v-form ref="formSecondStep" style="width: 100%;" lazy-validation v-on:submit.prevent>
                      <v-row>
                        <v-col cols="6" class="pb-0">
                          <v-text-field
                            :label="'Nombre de banco *'"
                            required
                            style="border-radius: 10px"
                            outlined
                            v-model="forms.new.sBank_name"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="pb-0">
                          <v-text-field
                            label="Account number *"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sAccount_number"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <div class="mb-8" style="background-color: #FFF8E4; display: flex; align-items: center; border-radius: 20px;">
                        <div class="ml-4" style="border-right: #FCCA3D solid 4px; height: 40px"></div>
                        <div class="pa-4" style="font-family: 'montserrat-semibold'; font-size: 14px">{{ "Por favor, asegúrate de ingresar el número de routing adecuado según el tipo de cuenta (wire/ACH)." }}</div>
                      </div>
                      <v-row>
                        <v-col cols="12" class="py-0">
                          <v-text-field
                            label="Routing Number *"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.routingNumber"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" class="py-0">
                          <v-select
                            :label="'Account type' + '*'"
                            required
                            outlined
                            :items="accountType"
                            style="border-radius: 10px"
                            v-model="forms.new.accountType"
                            :rules="[rules.required]"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" class="pt-0">
                          <v-select
                            :label="'Transfer method' + '*'"
                            required
                            outlined
                            :items="transferMethod"
                            style="border-radius: 10px"
                            item-value="id"
                            item-text="name"
                            v-model="forms.new.transferMethod"
                            :rules="[rules.required]"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <div class="mb-4" style="background-color: #BFD7ED; display: flex; align-items: center; border-radius: 20px;">
                        <div class="ml-4" style="border-right: #0075B8 solid 4px; height: 80px"></div>
                        <div style="display: flex; flex-direction: column;">
                          <div class="px-4 pt-3 pb-3" style="font-family: 'montserrat-semibold'; font-size: 14px">{{ "Los pagos vía Wire se procesan en aproximadamente 30 a 60 minutos (dentro del horario bancario) y los pagos ACH pueden demorar entre 1 y 3 días hábiles. " }}</div>
                          <div class="px-4 pb-3" style="font-family: 'montserrat-semibold'; font-size: 14px">{{ "Se aplicará un cargo por comisión (FEE) de $12.50 USD al utilizar wire." }}</div>
                        </div>
                      </div>
                    </v-form>
                  </v-row>
                  <v-row v-else-if="forms.new.sCountry === 'EUR'">
                    <v-form ref="formSecondStep" style="width: 100%;" lazy-validation v-on:submit.prevent>
                      <v-row>
                        <v-col cols="6" class="pb-0">
                          <v-text-field
                            :label="'Nombre de banco *'"
                            required
                            style="border-radius: 10px"
                            outlined
                            v-model="forms.new.sBank_name"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="pb-0">
                          <v-select
                            :label="'Currency Account *'"
                            required
                            outlined
                            :items="currencyOptions"
                            style="border-radius: 10px"
                            v-model="forms.new.currency"
                            :rules="[rules.required]"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6" class="pb-0">
                          <v-text-field
                            label="Account number *"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sAccount_number"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="pb-0">
                          <v-text-field
                            label="SWIFT Code *"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.swiftCode"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6" class="pb-0">
                          <v-text-field
                            :label="'Dirección' + '*'"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sAddress"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="pb-0">
                          <v-text-field
                            :label="'Código postal' + '*'"
                            required
                            hide-details
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.postCode"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row style="margin-top: -10px;">
                        <v-col cols="6" class="pt-0">
                          <v-text-field
                            :label="'Ciudad' + '*'"
                            required
                            hide-details
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sCity"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="pt-0">
                          <v-text-field
                            :label="'Estado' + '*'"
                            required
                            hide-details
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sState"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-row>
                </v-container>
              </v-card-text>
              <div v-else style="display: flex; justify-content: center;">
                <v-progress-circular
                  indeterminate
                  color="black"
                ></v-progress-circular>
              </div>
              <v-card-actions class="pb-4" style="justify-content: space-evenly;">
                <v-btn
                  color="black"
                  elevation="8"
                  class="mr-2 px-6"
                  style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                  outlined
                  :disabled="loading"
                  @click="step = 1, forms.new.currency = ''"
                >
                  {{ "Back" }}
                </v-btn>
                <v-btn
                  color="black"
                  elevation="8"
                  :disabled="loading"
                  class="white--text px-6"
                  style="border-radius: 36px; border: 2px solid black; font-family: 'montserrat-semibold'; text-transform: none;"
                  @click="saveBeneficiary()"
                >
                  {{ "Confirm" }}
                </v-btn>
              </v-card-actions>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogRecipient" v-if="dialogRecipient" persistent max-width="fit-content">
      <v-card>
        <v-btn @click="dialogRecipient = false" icon class="pl-0" style="position: absolute; right: 5px;">
          <v-icon class="mr-1" color="black" size="25px"> mdi-close</v-icon>
        </v-btn>
        <div class="mb-6 pt-6" style="text-align: center; font-family: 'montserrat-bold'; font-size: 20px;">{{ "Contact detail" }}</div>
        <v-skeleton-loader v-if="loadingRecipient" type="article" width="400" />
        <v-card-text v-else>
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  :label="'Nombre'"
                  required
                  readonly
                  hide-details
                  outlined
                  style="border-radius: 10px"
                  v-model="paymentRecipient.sName"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-select
                  :label="'País'"
                  required
                  readonly
                  hide-details
                  outlined
                  :items="country"
                  style="border-radius: 10px"
                  v-model="paymentRecipient.sCountry"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-4">
                <v-text-field
                  :label="'Email'"
                  required
                  readonly
                  outlined
                  hide-details
                  style="border-radius: 10px"
                  v-model="paymentRecipient.sEmail"
                ></v-text-field>
              </v-col>
              <v-col cols="12" v-if="paymentRecipient.sAddressLine">
                <v-text-field
                  :label="'Dirección'"
                  required
                  outlined
                  readonly
                  hide-details
                  style="border-radius: 10px"
                  v-model="paymentRecipient.sAddressLine"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" v-if="paymentRecipient.sCity">
                <v-text-field
                  :label="'Ciudad'"
                  required
                  hide-details
                  outlined
                  readonly
                  style="border-radius: 10px"
                  v-model="paymentRecipient.sCity"
                ></v-text-field>
              </v-col>
              <v-col cols="6" v-if="paymentRecipient.sState">
                <v-text-field
                  :label="'Estado'"
                  required
                  hide-details
                  outlined
                  readonly
                  style="border-radius: 10px"
                  v-model="paymentRecipient.sState"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pb-6">
                <v-text-field
                  :label="'Nombre del banco'"
                  required
                  hide-details
                  style="border-radius: 10px"
                  outlined
                  readonly
                  v-model="paymentRecipient.sBankName"
                ></v-text-field>
              </v-col>
              <v-col v-if="paymentRecipient.currency">
                <v-select
                  :label="'Moneda de la cuenta'"
                  required
                  outlined
                  readonly
                  :items="currency"
                  style="border-radius: 10px"
                  v-model="paymentRecipient.currency"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0" v-if="paymentRecipient.sAccountNumber">
                <v-text-field
                  :label="'Número de cuenta'"
                  required
                  outlined
                  readonly
                  style="border-radius: 10px"
                  v-model="paymentRecipient.sAccountNumber"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" v-if="paymentRecipient.accountNumber">
                <v-text-field
                  :label="'Account number'"
                  required
                  outlined
                  readonly
                  style="border-radius: 10px"
                  v-model="paymentRecipient.accountNumber"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" v-if="paymentRecipient.taxId">
                <v-text-field
                  :label="'RFC'"
                  required
                  outlined
                  readonly
                  style="border-radius: 10px"
                  v-model="paymentRecipient.taxId"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" v-if="paymentRecipient.sRoutingNumber">
                <v-text-field
                  label="Routing Number"
                  required
                  outlined
                  readonly
                  style="border-radius: 10px"
                  v-model="paymentRecipient.sRoutingNumber"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0" v-if="paymentRecipient.sAccountType">
                <v-select
                  :label="'Account type'"
                  required
                  outlined
                  readonly
                  :items="accountType"
                  style="border-radius: 10px"
                  v-model="paymentRecipient.sAccountType"
                ></v-select>
              </v-col>
              <v-col class="py-0" v-if="paymentRecipient.sTransferMethod">
                <v-select
                  :label="'Transfer method'"
                  required
                  outlined
                  readonly
                  :items="transferMethod"
                  style="border-radius: 10px"
                  item-value="id"
                  item-text="name"
                  v-model="paymentRecipient.sTransferMethod"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" v-if="dialogDelete" persistent max-width="fit-content">
      <v-card class="pt-5">
        <div style="display: flex; flex-direction: column; align-items: center;">
          <v-img :src="require('@/assets/icons/delete.svg')" style="width: 70px; height: 70px; margin-bottom: -40px;"></v-img>
          <v-card-title class="text-h5 my-4 mt-0 mx-10 pt-10 pb-6 px-8" style="border-radius: 10px; background-color: #E31D1C; color: white; font-family: 'montserrat-semibold' !important; text-align: center;">
            ¿Estás seguro de que deseas eliminar al proveedor?
          </v-card-title>
          <v-card-text v-if="!loadingRecipient" class="mt-4" style="text-align: center; font-family: 'montserrat-semibold'; font-size: 18px;">Una vez que eliminas al proveedor no podrás crear facturas asignadas a él.</v-card-text>
          <div v-else style="display: flex; justify-content: center;">
            <v-progress-circular
              indeterminate
              color="red"
            ></v-progress-circular>
          </div>
        </div>
        <v-card-actions class="pb-4 mt-8" style="justify-content: space-evenly;">
          <v-btn
            color="#0075B8"
            elevation="8"
            class="mr-2 px-6"
            style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
            outlined
            :disabled="loadingRecipient"
            @click="deletePaymentRecipient = null, dialogDelete = false"
          >
            {{ "Cancelar" }}
          </v-btn>
          <v-btn
            color="red"
            elevation="8"
            class="white--text px-6"
            style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
            :disabled="loadingRecipient"
            @click="deleteBeneficiary()"
          >
            {{ "Eliminar" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import moment from "moment";
  import * as XLSX from "xlsx";
  import { saveAs } from "file-saver";

  export default {
    name: "Beneficiarios",
    props: {
      activeTab: String,
      permissionList: Array,
      enterprise: Object
    },
    data() {
      return {
        paymentsRecipientsRaw: [],
        loadingRecipient: false,
        isLoading: true,
        deletePaymentRecipient: null,
        busqueda: "",
        dialogRequestPayment: false,
        dialogRecipient: false,
        dialogDelete: false,
        forward: null,
        createBeneficiary: false,
        step: 1,
        loading: false,
        rules: {
          required: (v) => !!v || "El campo es obligatorio",
          clabeLength: (v) => (v && v.length === 18) || "La cuenta clabe debe tener exactamente 18 caracteres",
        },
        forms: {
          new: {
            sName: "",
            sEmail: "",
            sBank_name: "",
            sAccount_number: "",
            clabe: "",
            sCountry: "",
            currency: "",
            sTaxId: "",
            accountType: "",
            sState: "",
            sCity: "",
            sAddress: "",
            transferMethod: "",
            swiftCode: "",
            postCode: "",
            sFirstName: "",
            sLastName: "",
            sEntityBusiness: "COMPANY",
            paymentMethodMX: "swift",
          },
        },
        step: 1,
        country: ['MX', 'USA', 'EUR'],
        currency: ['MXN', 'USD'],
        accountType: [
          { text: 'CHECKING', value: '1' },
          { text: 'SAVINGS', value: '2' },
        ],
        transferMethod: [
          { id: 1, name: 'WIRE' },
          { id: 2, name: 'ACH' }
        ],
        countryIdMap: {
          MX: 83,
          USA: 140,
          EUR: 140,
        },
      };
    },
    watch: {
      activeTab(val) {
        if (val === 'beneficiarios') {
          this.getPaymentRecipients();
        }
      }
    },
    computed: {
      entityBusinessItems() {
        return [
          { value: "COMPANY", text: "Company" },
          { value: "PERSON", text: "Person" },
        ];
      },
      currencyOptions() {
        if (this.forms.new.sCountry === 'EUR') {
          return ['USD', 'EUR'];
        }
        return this.currency;
      },
      paymentsRecipients() {
        if (!this.busqueda) return this.paymentsRecipientsRaw;

        const filtro = this.busqueda.toLowerCase();

        return this.paymentsRecipientsRaw.filter((item) => {
          return (
            item.sName?.toLowerCase().includes(filtro) ||
            item.sEmail?.toLowerCase().includes(filtro) ||
            item.sBankName?.toLowerCase().includes(filtro) ||
            item.sAccountNumber?.toLowerCase().includes(filtro) ||
            item.accountNumber?.toLowerCase().includes(filtro) ||
            item.sTaxId?.toLowerCase().includes(filtro) ||
            item.sAccountCurrency?.toLowerCase().includes(filtro) ||
            item.sCountry?.toLowerCase().includes(filtro)
          );
        });
      },
    },
    mounted() {
      if (this.activeTab === 'beneficiarios') {
        this.getPaymentRecipients();
      }
    },
    methods: {
      getPaymentRecipients() {
        this.isLoading = true;
        this.incomes = [];
        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
        };

        DB.post(`${URI}/api/v1/en/administrator/suppliers`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.paymentsRecipientsRaw = response.data.paymentRecipients;
          this.isLoading = false;
        }).catch((error) => {
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
      },
      nextStep() {
        if (this.$refs.formNew) {
          const isValid = this.$refs.formNew.validate();

          if (isValid) {
            this.step = 2;
          }
        }
      },
      async saveBeneficiary() {
        if (this.$refs.formSecondStep.validate()) {
          this.loading = true;

          const entityType = this.forms.new.sEntityBusiness || 'COMPANY';
          const firstName = this.forms.new.sFirstName || '';
          const lastName = this.forms.new.sLastName || '';
          const companyName = this.forms.new.sName || '';
          const email = this.forms.new.sEmail || '';
          const bankName = this.forms.new.sBank_name || '';
          const country = this.forms.new.sCountry || '';
          const currency = this.forms.new.sCountry === 'USA' ? 'USD' : this.forms.new.currency;
          const isPerson = entityType === 'PERSON';
          const isCompany = !isPerson;
          const isMxUsd = country === 'MX' && currency === 'USD';
          const usesSwift = country === 'EUR' || (isPerson && isMxUsd) || (isCompany && isMxUsd);
          const normalizedCountry = country === 'EUR' ? 'USA' : country;
          const countryIdMap = { MX: 83, USA: 140, EUR: 140 };
          const countryId = country ? countryIdMap[country] || null : null;

          const payload = {
            sEnterpriseId: this.$route.params.sEnterpriseId,
            email,
            contactTypeId: usesSwift ? 2 : 1,
            country: normalizedCountry,
            countryId,
            phoneNumber: null,
            entityType,
            ...(isPerson ? { firstName, lastName } : { name: companyName }),
            accountCurrency: currency,
            bank_name: bankName,
            ...(this.forms.new.clabe && { clabe: this.forms.new.clabe }),
            ...(this.forms.new.sTaxId && { sTaxId: this.forms.new.sTaxId }),
            // Campos bancarios USA
            ...(this.forms.new.sAccount_number && { sAccountNumber: this.forms.new.sAccount_number }),
            ...(this.forms.new.routingNumber && { routingNumber: this.forms.new.routingNumber }),
            ...(this.forms.new.accountType && { accountType: this.forms.new.accountType }),
            ...(this.forms.new.transferMethod && { transferMethod: String(this.forms.new.transferMethod) }),
            // SWIFT (para MX-USD o EUR)
            ...(this.forms.new.swiftCode && { swiftCode: this.forms.new.swiftCode }),
            // Dirección (requerida para USD)
            ...(this.forms.new.sAddress && { sAddress: this.forms.new.sAddress }),
            ...(this.forms.new.sCity && { sCity: this.forms.new.sCity }),
            ...(this.forms.new.sState && { sState: this.forms.new.sState }),
            ...(this.forms.new.postCode && { postCode: this.forms.new.postCode })
          };

          DB.post(
              `${URI}/api/v1/en/administrator/createBeneficiary/v2`,
              payload,
              {
                headers: {
                  Authorization: this.$store.state.sToken
                    ? `Bearer ${this.$store.state.sToken}`
                    : ""
                }
              }
            )
          .then((response) => {
            this.loading = false;
            this.step = 1;
            this.forms.new = {
              sName: "",
              sEmail: "",
              sBank_name: "",
              sAccount_number: "",
              clabe: "",
              sCountry: "",
              currency: "",
              sTaxId: "",
              accountType: "",
              sState: "",
              sCity: "",
              sAddress: "",
              transferMethod: "",
              swiftCode: "",
              postCode: "",
              sFirstName: "",
              sLastName: "",
              sEntityBusiness: "COMPANY",
              paymentMethodMX: "swift",
            };
            this.createBeneficiary = false;
            this.getPaymentRecipients();
            this.mixSuccess(response.data.message);
          })
          .catch((error) => {
            this.loading = false;
            this.mixError(error.response.data.message, error.response.status);
          });
        } else {
          this.error = true;
          this.codeError = "INVALID_INPUT";
        }
      },
      getBeneficiary(item) {
        this.paymentRecipient = null;
        this.loadingRecipient = true;
        this.dialogRecipient = true;

        const payload = {
          sPaymentRecipientId: item.sPaymentRecipientId
        };

        DB.post(`${URI}/api/v1/en/administrator/getBeneficiary`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.paymentRecipient = response.data.paymentRecipient;
          this.loadingRecipient = false;
          this.paymentRecipient.sTransferMethod = Number(this.paymentRecipient.sTransferMethod);
        }).catch((error) => {
          this.loadingRecipient = false;
          this.mixError(error.response.data.message, error.response.status);
        });
      },
      deleteBeneficiary() {
        this.loadingRecipient = true;
        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          sPaymentRecipientId: this.deletePaymentRecipient.sPaymentRecipientId
        };

        DB.post(`${URI}/api/v1/en/administrator/deleteBeneficiary`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.loadingRecipient = false;
          this.dialogDelete = false;
          this.deletePaymentRecipient = null;
          this.getPaymentRecipients();
          this.mixSuccess(response.data.message);
        }).catch((error) => {
          this.loadingRecipient = false;
          this.mixError(error.response.data.message, error.response.status);
        });
      },
      formatDate: function (date) {
        if (this.selectLanguage === "sp") {
          moment.locale("es");
        } else {
          moment.locale("en");
        }
        let newDate = moment(date);
        let formattedDate = newDate.format("MMMM DD, YYYY HH:mm a");
        return formattedDate;
      },
      dataXLSX() {
        try {
          let data = this.paymentsRecipientsRaw.map((item) => {
            return {
              sName: item.sName ? item.sName : "-",
              sEmail: item.sEmail ? item.sEmail : "-",
              sBankName: item.sBankName ? item.sBankName : "-",
              sAccountNumber: item.sAccountNumber ? item.sAccountNumber : "-",
              accountNumber: item.accountNumber ? item.accountNumber : "-",
              sTaxId: item.sTaxId ? item.sTaxId : "-",
              sAccountCurrency: item.sAccountCurrency ? item.sAccountCurrency : "-",
              sCountry: item.sCountry ? item.sCountry : "-",
              };
          });
          const worksheet = XLSX.utils.json_to_sheet(data);

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Hoja1");

          const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

          const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

          saveAs(blob, "Beneficiarios.xlsx");
          this.success = true;
          this.msgSuccess = "Descargando documento";
        } catch (error) {
          this.error = true;
          this.codeError = "CSV_NO_DATA";
        }
      },
      beneficiaryDetail(item) {
        this.$router.push({
          name: "BeneficiaryDetail",
          params: { sEnterpriseId: item.sEnterpriseId, sPaymentRecipientId: item.sPaymentRecipientId }
        }).catch(() => {});
      }
    }
  };
</script>
<style scoped>
</style>
